/**
 * contains the abi and contract address
*/

class XanaduContract {
    constructor() {
        this.abi = [
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "annotationType",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "data",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "annotationData",
				"type": "bytes32"
			}
		],
		"name": "newAnnotation",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "annotationType",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "data",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "annotationData",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
		],
		"name": "NewAnnotation",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "annotationType",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "data",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[]",
				"name": "annotationData",
				"type": "bytes32[]"
			}
		],
		"name": "newAnnotations",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "annotationType",
				"type": "bytes32"
			},
			{
				"internalType": "string",
				"name": "description",
				"type": "string"
			}
		],
		"name": "newAnnotationType",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "annotationType",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "description",
				"type": "string"
			}
		],
		"name": "NewAnnotationType",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "dataType",
				"type": "bytes32"
			},
			{
				"internalType": "string",
				"name": "description",
				"type": "string"
			}
		],
		"name": "newDataType",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "dataType",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "description",
				"type": "string"
			}
		],
		"name": "NewDataType",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "linkType",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "fromData",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "toData",
				"type": "bytes32"
			}
		],
		"name": "newLink",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "linkType",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "fromData",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "toData",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
		],
		"name": "NewLink",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "linkType",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "fromData",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
		],
		"name": "NewLinkRoot",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "linkType",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "fromData",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32[]",
				"name": "toData",
				"type": "bytes32[]"
			}
		],
		"name": "newLinks",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "linkType",
				"type": "bytes32"
			},
			{
				"internalType": "string",
				"name": "description",
				"type": "string"
			}
		],
		"name": "newLinkType",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "linkType",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "description",
				"type": "string"
			}
		],
		"name": "NewLinkType",
		"type": "event"
	}
        ];
            
        this.contractAddress = '0x305306F68D9C230B59d5B6869AEd1723365C9290';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default XanaduContract;
